import Vue from 'vue'
import { createAndMountInstance } from 'util/loader-helper'
import { widgetLibraries } from 'init/command-queue'
import * as commentsPinboardCommands from './comments-pinboard-commands'
import commentsPinboardStore from 'store/comments-pinboard-store'
import { CommentsPinboardConfig as ICommentsPinboardConfig } from 'services/api-service'
import commentsPinboardConfig, { loadConfig } from './comments-pinboard.config'
import CommentsPinboard from './comments-pinboard'


let root: Vue

export const type = 'comments-pinboard'

export function initialize() {
  return createAndMountInstance(root, CommentsPinboard, commentsPinboardConfig.widgetDivId)
    .then(instance => root = instance)
}

export function loadWidget(widgetConfig: ICommentsPinboardConfig) {
  return new Promise((resolve) => {
    loadConfig(widgetConfig)
    widgetLibraries.commentsPinboard = commentsPinboardCommands
    // check turnToConfig for filter values (skus, brands, tags)
    const pinboardTurnToConfig = window.turnToConfig.commentsPinboard || {}
    commentsPinboardStore.brands = pinboardTurnToConfig.brands || []
    commentsPinboardStore.skus = pinboardTurnToConfig.skus || []
    commentsPinboardStore.tags = pinboardTurnToConfig.tags || []
    initialize().then(() => resolve())
  })
}

export function getInstance() {
  return root
}
